// These are the 'prettified' versions of the fields to be displayed in the Compare and Update screen
import { grades } from './default-objects'

const fieldLookupTable =
  {
    firstName: {
      label: 'First Name',
      type: 'text',
      required: true,
    },
    lastName: {
      label: 'Last Name',
      type: 'text',
      required: true,
    },
    sex: {
      label: 'Sex',
      type: 'radio',
      required: true,
      options: ['M', 'F'],
    },
    birthDate: {
      label: 'Birth Date',
      type: 'date',
      required: true,
    },
    bornInUS:{
      label: 'Born In US or PR',
      type: 'radio',
      required: true,
      options: ['Yes', 'No'],
    },
    firstUSEnrollmentDate: {
      label: 'First Enrollment Date (US)',
      type: 'date',
      required: true,
    },
    enrollingAt: {
      label: 'Enrolling At (School Code)',
      type: 'select',
      optionsUrl: '/public/schools',
      required: true,
    },
    enrollingAtDate: {
      label: 'Year for Current School',
      type: 'text',
      required: true,
    },
    gradeEntering: {
      label: 'Entering Grade',
      type: 'select',
      required: true,
      options: grades,
      optionsUrl: null,
    },
    screenerName: {
      label: 'Contact',
      type: 'none',
      required: true,
    },
    screenedDate: {
      label: 'Date of Screening',
      type: 'none',
      required: true,
    },
    permNumber: {
      label: 'PERM Number',
      type: 'text',
      required: true,
      isShown: true,
      isDisabled: true,
    },
    dateFieldsToFormat: [
      'birthDate',
      'firstUSEnrollmentDate',
      'screenedDate',
      'enrollingAtDate',
    ],
    fieldOrder: [
      'firstName',
      'lastName',
      'sex',
      'birthDate',
      'firstUSEnrollmentDate',
      'enrollingAt',
      'enrollingAtDate',
      'gradeEntering',
      'permNumber',
      'screenerName',
      'screenedDate',
    ],
  }


export default fieldLookupTable